import { RouteLocationNormalized } from "vue-router"

export const preserveTable = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: (arg?: any) => void
) => {
  const isFromMenu = from.path.startsWith('/qr-menu/')
  const isToMenu = to.path.startsWith('/qr-menu/')

  // console.log('[preserveTable]', { isFromMenu, isToMenu, fromQuery: from.query, toQuery: to.query })

  if (isFromMenu && isToMenu) {
    const hasTable = from.query.table
    const needsTable = !to.query.table

    if (hasTable && needsTable) {
      return next({
        name: to.name || undefined,
        params: to.params,
        query: { ...from.query, ...to.query },
        replace: true,
      })
    }
  }

  next()
}
